import SqFetch from 'application/fetch';
import { BASE_DOMAIN, getEnv } from 'utilities/environment';

export default class CapitalShopClient {
  // TODO: Remove hardcoding of domain and use enviornment.js getDomain when domain separation is complete
  constructor(applicationFlowToken) {
    this.env = getEnv();
    this.domain =
      this.env === 'production'
        ? `app.${BASE_DOMAIN.PRODUCTION}`
        : `app.${BASE_DOMAIN.STAGING}`;

    this.apiBaseUrl = `https://${this.domain}/api/v2/capital-shop/application-flows/${applicationFlowToken}`;
  }

  getApplicationFlow() {
    if (this.env === 'development') {
      return Promise.resolve({
        data: {
          attributes: {
            status: 'pending',
            personal_first_name: 'Stephen',
            personal_last_name: 'Curry',
            personal_street_1: '1 Warriors Way',
            personal_street_2: '',
            personal_city: 'SAN FRANCISCO',
            personal_state_province: 'CA',
            personal_postal_code: '94158',
            personal_birthdate: null,
            personal_ssn: null,
            accepted_legal_agreements: false,
          },
        },
      });
    }
    return SqFetch.get(this.apiBaseUrl).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response);
    });
  }

  submitApplicationFlow(formData) {
    if (this.env === 'development') {
      return Promise.resolve({
        data: {
          attributes: {
            status: 'submitted',
          },
        },
      });
    }
    return SqFetch.post(`${this.apiBaseUrl}/submit`, {
      data: { attributes: formData, type: 'application_flows' },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response);
    });
  }
}
